// School country flags: the domain TLD is unreliable (.com, .education, .edu…)
const PROJECT_FLAGS: Record<string, string> = {
  '01.gritlab.ax': '🇦🇽',
  '01.nextera.education': '🇪🇬',
  '01yessenov.yu.edu.kz': '🇰🇿',
  'acad.learn2earn.ng': '🇳🇬',
  'adam-jerusalem.nd.edu': '🇮🇱',
  'learn.01founders.co': '🇬🇧',
  'learn.reboot01.com': '🇧🇭',
  'learn.zone01dakar.sn': '🇸🇳',
  'learn.zone01kisumu.ke': '🇰🇪',
  'learn.zone01oujda.ma': '🇲🇦',
  'letmeincatalyst.posspole.com': '🇮🇳',
  'platform.zone01.gr': '🇬🇷',
  'ytrack.learn.ynov.com': '🇫🇷',
  'zone01normandie.org': '🇫🇷',
}

export const ProjectDomain = ({ domain }: { domain: string }) => {
  const flag = PROJECT_FLAGS[domain]
  return (
    <>
      {domain}
      {flag && ` ${flag}`}
    </>
  )
}
